'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_RulesTable$$anon$7() {
}
export { $c_Lpresto_RulesTable$$anon$7 as $c_Lpresto_RulesTable$$anon$7 };
$p = $c_Lpresto_RulesTable$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RulesTable$$anon$7;
/** @constructor */
function $h_Lpresto_RulesTable$$anon$7() {
}
export { $h_Lpresto_RulesTable$$anon$7 as $h_Lpresto_RulesTable$$anon$7 };
$h_Lpresto_RulesTable$$anon$7.prototype = $p;
$p.aR = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, item.cq5(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().m);
});
var $d_Lpresto_RulesTable$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RulesTable$$anon$7, "presto.RulesTable$$anon$7", ({
  Qy: 1,
  A: 1
}));
export { $d_Lpresto_RulesTable$$anon$7 as $d_Lpresto_RulesTable$$anon$7 };
//# sourceMappingURL=presto.-Rules-Table$$anon$7.js.map
